import styled from 'styled-components/macro';

import Cell from 'components/data-visualization/Table/Cell';
import Table from 'components/data-visualization/Table/Table';
import Row from 'components/data-visualization/Table/Row';
import { StyledEntityItem } from 'components/data-containers/BrowseEntities/TableRow/TableRow.style';

export const StyledCell = styled(Cell)<any>`
  display: flex;
  flex-direction: column;

  &.artist {
    padding-bottom: 2em;
    border-bottom: 1px solid ${({ theme }): string => theme.LightGrey};

    @media screen and (min-width: 50em) and (max-width: 60em) {
      padding-bottom: 1.5em;
    }
  }
  &.metric {
    padding-left: 65px;
    position: absolute;
    bottom: 15px;
  }

  ${StyledEntityItem} {
    align-items: flex-start;
  }

  @media screen and (min-width: 60em) {
    display: table-cell;
    border-bottom: 1px solid ${({ theme }): string => theme.LightGrey};

    &.artist {
      padding-bottom: ${({ theme }): string => theme.spacing.xsmall};
    }
    &.metric {
      width: 130px;
      position: initial;
      padding-left: ${({ theme }): string => theme.spacing.xsmall};
    }
  }
`;

export const StyledTable = styled(Table)`
  @media screen and (min-width: 60em) {
    padding: 0 1em 0 0.5em;
  }
`;

export const Text = styled('span')`
  color: #011446;
  font-size: 0.875em;
  line-height: 1em;
`;

export const StyledRow = styled(Row)`
  @media screen and (max-width: 60em) {
    position: relative;
  }
`;
